import { Phone, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SITE } from "@/data/site";
import { scrollToGetStarted } from "@/components/CTA";

export const MobileCTA = () => {
  const navigate = useNavigate();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-2 border-t border-white/10 bg-navy-deep/95 p-3 backdrop-blur-lg md:hidden"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={SITE.phoneTel}
        data-testid="mobile-cta-call-now"
        className="flex items-center justify-center gap-2 rounded-full border border-gold/50 py-3 font-display text-sm font-bold uppercase tracking-wide text-gold"
      >
        <Phone className="h-4 w-4" />
        Call Now
      </a>
      <button
        type="button"
        data-testid="mobile-cta-get-started"
        onClick={() => scrollToGetStarted(navigate)}
        className="flex items-center justify-center gap-2 rounded-full bg-gold py-3 font-display text-sm font-bold uppercase tracking-wide text-navy"
      >
        Get Started
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default MobileCTA;
